import { usePage } from '@inertiajs/vue3';

export const hasPermission = (permission) => {
    const page = usePage();
    let permissionNames = page.props.currentUser.permissionNames;

    return permissionNames.indexOf(permission) !== -1;
};

export const hasPermissions = (permissions) => {
    const page = usePage();
    let permissionNames = page.props.currentUser.permissionNames;

    return permissions.some(
        (permission) => permissionNames.indexOf(permission) !== -1,
    );
};

export const hasRole = (role) => {
    const page = usePage();
    let roleNames = page.props.currentUser.roleNames;

    return roleNames.indexOf(role) !== -1;
};

export const isSuperAdmin = () => {
    return hasRole('super-admin-datakepler');
};
